import { RouteObject } from "react-router-dom";

export async function loadCustomerRoutes(appKey: string): Promise<RouteObject[]> {
  const loweredAppKey = appKey.toLowerCase();

  switch (loweredAppKey) {
    case "google":
      return (await import("../apps/google/routes")).googleRoutes;
    case "olive":
      return (await import("../apps/olive/routes")).oliveRoutes;
    default:
      return []; // no routes available if there is no Customer Application
  }
}